import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { Router } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import * as alerts from '../../../_functions/alerts';
import * as _ from 'lodash';
import { AuthService } from 'src/app/modules/_services/auth.service';
import { LocationService } from 'src/app/modules/_services/location.service';
import { ValidacaoService } from 'src/app/modules/_services/validacao.service';
import { TitleCasePipe } from '@angular/common';
import { Niveis } from 'src/app/modules/_models/Enums/niveis';

const MESES: string[] = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

@Component({
  selector: 'app-detalhes-experiencia',
  templateUrl: './detalhes-experiencia.component.html',
  styleUrls: ['./detalhes-experiencia.component.scss'],
  providers: [TitleCasePipe],
})
export class DetalhesExperienciaComponent implements OnInit {
  @Input() public idExperiencia: number = 0;
  @Input() public idExperienciaParceiro: number = 0;
  @Input() public cpfMembro: string = '';
  @Input() public membroCacaus: number = 0;
  @Input() public imagemSrc: string = '';
  @Input() public nome: string = '';
  @Input() public descricao: string;
  @Input() public niveis: any[] = [];
  @Input() public parceirosLogoSrc: string[] = [];
  @Input() public quantidadeDisponivel: number = 1;
  @Input() public pontuacao: number = 0;
  @Input() public quantidadePorMembro: number = 1;
  @Input() public lotes: any[] = [];
  @Input() public selecionaLocal: boolean = false;
  @Input() public loteCustomizado: boolean = false;
  @Input() public tag: string = '';
  @Input() public parceiroId: number = 0;
  @Input() public quantidadeAcompanhantes: number = 0;
  @Input() public mensagemResgateDefault: string = '';
  @Input() public membro: any = null;
  @Input() public possuiQuantidadeLoteAtual: any = null;
  @Input() public dataProximoLoteDisponivel: any = null;

  @Output() public abrirLocaisDisponiveis: EventEmitter<null> =
    new EventEmitter();

  public pontuacaoFinal: number = 0;
  public experienciaNivelClasse: string = '';
  public resgatandoExperiencia: boolean = false;
  public experienciaEsgotada: boolean = false;
  public popupExperienciaEsgotada: boolean = false;
  public abrirPopupResgate: boolean = false;
  public messageDisabled: string = 'Esta experiência';

  public experienciaLotes: any[] = [];
  public idLoteSelecionado: number = 0;
  public idDataSelecionada: number = -1;
  public loteSelecionado: any = null;
  public loteQuantidadeSelecionada: number = 1;
  public pontuacaoLoteFinal: number = 0;
  public condicaoResgate: any = null;

  public tipo: number = 0;

  public maximoPopup: number = 1;

  public enderecosLote: any[] = [];
  public enderecoSelecionado: any = null;

  public cep: string = '';
  public numero: string = '';

  public buscandoEndereco: boolean = false;

  public listaEnderecos: any[] = [];

  public exibirPopupResgatado: boolean = false;
  public experienciaResgatada: any;
  public exibirPopupCondicoesResgate: boolean = false;

  public acompanhantes: any[] = [];

  public aceiteRegras: boolean = false;

  public limiteAtingido: boolean = false;
  public idPosicaoLoteSelecionado: number = 0;

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router,
    private authService: AuthService,
    private locationService: LocationService,
    private validacaoService: ValidacaoService,
    private titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit(): void {
    this.tratarDados();
    this.obterParceiroEndereco();
    this.obterNiveisOrdenados();
  }

  private tratarDados(): void {
    this.pontuacaoFinal = this.pontuacao;
    this.maximoPopup = this.quantidadePorMembro;

    this.experienciaEsgotada = !this.possuiQuantidadeLoteAtual;
    this.popupExperienciaEsgotada = this.experienciaEsgotada;

    var acompanhantes: any[] = [];
    for (let i = 0; i < this.quantidadeAcompanhantes; i++) {
      acompanhantes.push({
        documento: '',
        nome: '',
      });
    }
    this.acompanhantes = acompanhantes;

    this.tratarLotes();
  }

  public obterNiveisOrdenados(): any[] {
    let niveisSolicitados = _.filter(this.niveis, (nivel: any) => {
      return nivel.idNivel != 9;
    });

    return _.orderBy(niveisSolicitados, (nivel: any) => {
      return nivel.idNivel;
    });
  }

  public obterClasse(descricaoNivel: string): string {
    let classe = '';

    switch (descricaoNivel.toLocaleLowerCase()) {
      case 'paixão':
        classe = 'nivel--paixao';
        break;
      case 'amor':
        classe = 'nivel--amor';
        break;
      case 'paquera':
        classe = 'nivel--paquera';
        break;
      case 'mozão':
        classe = 'nivel--mozao';
        break;
      case 'embaixador':
          classe = 'nivel--embaixador';
          break;
    }

    if(this.membro.idNivel != Niveis.Mozao)
      classe += ' nivel--mozao-desabilitado';

    if(this.membro.idNivel != Niveis.Embaixador)
      classe += ' nivel--embaixador-desabilitado';

    return classe;
  }

  private definirTipo() {
    // 1 - Resgate direto (somente com mensagem de validação)
    // 2 - Possui data, endereço e seleciona
    // 3 - Seleciona e possui data (lista todos os endereços)
    // 4 - Seleciona e possuí endereço (escolhe um endereço específico)
    // 5 - Não seleciona e possui data
    // 6 - Seleciona (lista todos os endereços)

    this.tipo = 1;
    if (!this.loteCustomizado) return;

    const lote = this.lotes[0];

    if (lote !== undefined) {
      if (this.selecionaLocal) {
        if (lote.dataEvento !== null && lote.parceiroEndereco !== null)
          this.tipo = 2;
        if (lote.dataEvento !== null && lote.parceiroEndereco === null)
          this.tipo = 3;
        if (lote.dataEvento === null && lote.parceiroEndereco !== null)
          this.tipo = 4;
        if (lote.dataEvento === null && lote.parceiroEndereco === null)
          this.tipo = 6;
      } else {
        if (lote.dataEvento !== null && lote.parceiroEndereco === null)
          this.tipo = 5;
      }
    }
  }

  private tratarLotes(): void {
    this.definirTipo();

    if (this.tipo === 1 || this.tipo === 6) return;

    if (this.tipo === 4) {
      this.tratarLotePorEndereço();
      return;
    }

    this.tratarLotePorData();
  }

  private tratarLotePorEndereço(): void {
    const tempLotes = this.lotes;
    const enderecosLotes: any[] = [];

    for (let i = 0; i < tempLotes.length; i++) {
      if(tempLotes[i].quantidadeDisponivel > 0)
      {
        const endereco = {
          ...tempLotes[i].parceiroEndereco.endereco,
          id: tempLotes[i].parceiroEndereco.idEndereco,
          descricao: tempLotes[i].parceiroEndereco.descricao,
        };

        enderecosLotes.push({
          parceiroEndereco: endereco,
          id: tempLotes[i].id,
        });
      }
    }

    this.enderecosLote = enderecosLotes;
  }

  private tratarLotePorData(): void {
    const tempLotes = this.lotes;
    const tempMesesLotes: any[] = [];

    tempLotes.forEach((tempLote: any) => {
      const dataEventoSplit = tempLote.dataEvento.split('T');
      tempLote.dataDoEvento = dataEventoSplit[0];
      const horaEvento = dataEventoSplit[1].split(':');
      tempLote.horaDoEvento = horaEvento[0] + ':' + horaEvento[1];

      const mesNumero: number = Number(tempLote.dataDoEvento.split('-')[1] - 1);
      const ano: number = tempLote.dataDoEvento.split('-')[0];
      const mes: any = {
        descricao: MESES[mesNumero] + ' de ' + ano,
        mes: tempLote.dataDoEvento.split('-')[1],
        mesInt: Number(tempLote.dataDoEvento.split('-')[1]),
        datas: [],
      };

      var existe: boolean = false;

      tempMesesLotes.forEach((mesLote: any) => {
        if (mesLote.descricao === mes.descricao) existe = true;
      });

      if (!existe) tempMesesLotes.push(mes);
    });

    const diasLotes = _.groupBy(tempLotes, function (itemTempLot: any) {
      return itemTempLot.dataDoEvento;
    });

    let idMes: number = 0;

    for (let key in diasLotes) {
      const diaLote = diasLotes[key];
      const mes = key.toString().split('-')[1];

      for (let i = 0; i < tempMesesLotes.length; i++)
        if (tempMesesLotes[i].mes == mes) {
          tempMesesLotes[i].datas.push({
            id: idMes++,
            data: key,
            dia: key.toString().split('-')[2],
            diaSemana: this.obterDiaDaSemana(key),
            horarios: [],
          });
        }

      for (let i = 0; i < tempMesesLotes.length; i++)
        for (let j = 0; j < tempMesesLotes[i].datas.length; j++)
          diaLote.forEach((diaLoteHorario) => {
            if (diaLoteHorario.dataDoEvento === tempMesesLotes[i].datas[j].data)
              tempMesesLotes[i].datas[j].horarios.push(diaLoteHorario);
          });
    }

    var experienciaLotes = _.orderBy(tempMesesLotes, (e: any) => {
      return e.mesInt;
    });

    this.experienciaLotes = experienciaLotes;
  }

  public selecionarMesLote(idLote: number) {
    this.idDataSelecionada = -1;
    this.loteSelecionado = null;
    this.pontuacaoLoteFinal = this.pontuacao;
    this.loteQuantidadeSelecionada = 1;
    this.enderecoSelecionado = null;
    this.idPosicaoLoteSelecionado = idLote;
    this.idLoteSelecionado = 0;
  }
  public selecionarData(id: number) {
    this.loteSelecionado = null;
    this.loteQuantidadeSelecionada = 1;
    this.pontuacaoLoteFinal = this.pontuacao;
    this.enderecoSelecionado = null;
    this.idDataSelecionada = id;
  }
  public selecionarLote(lote: any) {
    this.loteQuantidadeSelecionada = 1;
    this.pontuacaoLoteFinal = this.pontuacao;
    this.enderecoSelecionado = null;
    this.loteSelecionado = lote;
    this.idLoteSelecionado = lote.id;
    this.tratarQuantidade(lote, this.loteQuantidadeSelecionada);
  }

  definirTituloEndereco() {
    if (this.loteSelecionado == null) return 'Nenhum endereço selecionado';
    if (this.loteSelecionado.parceiroEndereco === null)
      return 'Disponível em todas unidades';

    const endereco = this.loteSelecionado.parceiroEndereco;

    return `${endereco.logradouro}, ${endereco.numero}`;
  }

  definirDescricaoEndereco() {
    if (this.loteSelecionado == null) return 'Escolha uma data e um horário';
    if (this.loteSelecionado.parceiroEndereco === null)
      return 'Utilize onde quiser';

    const endereco = this.loteSelecionado.parceiroEndereco;
    return `${endereco.bairro}, ${endereco.cidade}, ${endereco.estado}`;
  }

  definirTitulo(lote: any) {
    const endereco = lote.parceiroEndereco;
    return `${endereco.descricao}`;
  }

  definirDescricao(lote: any) {
    const endereco = lote.parceiroEndereco;
    return `${endereco.bairro}, ${endereco.cidade}, ${endereco.estado}`;
  }

  selecionarEndereco(loteEndereco: any): void {
    this.selecionarLoteDefault(loteEndereco.id);
    this.enderecoSelecionado = loteEndereco;
  }

  onClickUnidadesDisponiveis(): void {
    this.abrirLocaisDisponiveis.emit();
  }

  definirTextoParceiro(): string {
    if (this.parceirosLogoSrc.length > 1) return 'Parceiros';
    return 'Parceiro';
  }

  onQuantidadeLoteChange(quantidade: any): void {
    this.tratarQuantidade(this.loteSelecionado, quantidade);
  }

  validarCondicaoResgate(): void {
    this.condicaoResgate = null;
    this.resgatandoExperiencia = true;

    this.fidelidadeService
      .obterValidacoesDeCondicaoDeResgate(this.idExperiencia, this.cpfMembro)
      .subscribe({
        next: (res: any) => this.processarSucessoObterCondicoesResgate(res),
        error: (err: any) => {
          this.resgatandoExperiencia = false;
          this.abrirPopupResgatar();
        },
      });
  }

  private processarSucessoObterCondicoesResgate(res: any): void {
    this.resgatandoExperiencia = false;
    var result = res.resultado;

    if (result.isValid) {
      this.abrirPopupResgatar();
      return;
    }

    this.exibirPopupCondicoesResgate = true;
    this.condicaoResgate = result;
  }

  abrirPopupResgatar(): void {
    this.selecionarLoteDefault(this.idLoteSelecionado);
    this.abrirPopupResgate = true;
  }

  private validarAcompanhante(acompanhante: any): boolean {
    if (acompanhante.nome == '' && acompanhante.documento == '') return true;
    return (
      this.validacaoService.validarCPF(acompanhante.documento) &&
      acompanhante.nome.length >= 5 &&
      acompanhante.nome.includes(' ')
    );
  }

  resgatarExperiencia(): void {
    const acompanhantes: string[] = [];
    for (let i = 0; i < this.acompanhantes.length; i++) {
      const acompanhante = this.acompanhantes[i];

      if (!this.validarAcompanhante(acompanhante)) {
        alerts.exibirToast(
          'warning',
          `Acompanhante ${this.titleCasePipe.transform(acompanhante.nome)} (${
            acompanhante.documento
          }) com dados inválidos, verifique se preencheu os dados corretamente.`
        );
        continue;
      }

      if (acompanhante.nome !== '')
        acompanhantes.push(
          `${this.titleCasePipe.transform(acompanhante.nome)};${
            acompanhante.documento
          }`
        );
    }

    const resgate = {
      idExperienciaParceiro: this.idExperienciaParceiro,
      documento: this.cpfMembro,
      quantidade: this.loteQuantidadeSelecionada,
      idExperienciaLote: this.idLoteSelecionado,
      idParceiroEndereco: 0,
      acompanhantes: acompanhantes.join('#')
    };

    if (this.tipo === 3 || this.tipo === 4 || this.tipo === 6)
      resgate.idParceiroEndereco = this.enderecoSelecionado.parceiroEndereco.id;

    if (this.tipo === 2)
      resgate.idParceiroEndereco = this.loteSelecionado.parceiroEndereco.id;

    this.resgatandoExperiencia = true;
    this.buscandoEndereco = true;
    this.fidelidadeService
      .resgatarExperiencia(
        resgate.idExperienciaParceiro,
        resgate.documento,
        resgate.quantidade,
        resgate.idExperienciaLote,
        resgate.idParceiroEndereco,
        resgate.acompanhantes
      )
      .subscribe({
        next: (res: any) => this.processarSucessoResgatar(res),
        error: (err: any) => this.processarFalhaResgatar(err),
      });
  }

  private processarSucessoResgatar(res: any): void {
    this.buscandoEndereco = false;
    this.resgatandoExperiencia = false;
    this.abrirPopupResgate = false;
    this.exibirPopupResgatado = true;
    this.experienciaResgatada = res.resultado;

    this.fidelidadeService.obterMembro().subscribe({
      next: (res: any) => this.authService.LocalStorage.salvarMembro(res)
    });
  }

  public irParaMinhasExperiencias() {
    this.router.navigate(['/minhas-experiencias']);
  }

  public abrirLink(url: string) {
    window.open(url, '_blank');
    this.exibirPopupCondicoesResgate = false;
  }

  private processarFalhaResgatar(err: any): void {
    console.error('Um erro ocorreu ao tentar resgatar uma experiência', err);
    let swalText: string = '';

    this.limiteAtingido = false;
    err.mensagensErro.forEach((erro: string) => {
      if(erro == "Não foi possível resgatar esta experiência! Você atingiu a quantidade máxima de resgates desta experiência." || erro.indexOf("Poderá regatar novamente") > 0)
      {
        this.limiteAtingido = true;

        if(erro.indexOf("Poderá regatar novamente") > 0)
          this.dataProximoLoteDisponivel = erro.split('Poderá regatar novamente em')[1];

        return;
      }
      else
      {
        erro = erro.replace('Membro', 'Você');
        swalText += erro + '';
      }
    });

    if(swalText != '')
    {
      Swal.fire({
        icon: 'info',
        title: 'Não foi possível resgatar a experiência!',
        text: swalText,
        confirmButtonColor: '#521b05',
      });
    }

    this.resgatandoExperiencia = false;
    this.buscandoEndereco = false;
  }

  public obterDiaDaSemana(dataStr: string): string {
    var dataSplit = dataStr.split('-');

    const data = new Date(
      Number(dataSplit[0]),
      Number(dataSplit[1]) - 1,
      Number(dataSplit[2])
    );

    const dias: string[] = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
    const dia = data.getDay();

    return dias[dia];
  }

  public obterDia(dataStr: string) {
    return dataStr;
  }

  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider = document.getElementById('data-mes');

  startDragging(e, flag, el) {
    this.mouseDown = true;
    this.startX = e.pageX - el.offsetLeft;
    this.scrollLeft = el.scrollLeft;
  }
  stopDragging(e, flag) {
    this.mouseDown = false;
  }
  moveEvent(e, el) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - el.offsetLeft;
    const scroll = x - this.startX;
    el.scrollLeft = this.scrollLeft - scroll;
  }

  public buscarEndereco(): void {
    this.buscandoEndereco = true;

    this.authService.loginOms().subscribe({
      next: (token: any) => {
        this.locationService
          .obterEndereco(token.token, this.cep, this.numero)
          .subscribe({
            next: (res: any) => this.processarSucessoObterEndereco(res),
            error: (err: any) => this.processarFalhaObterProximos(err),
          });
      },
    });
  }

  public buscarEnderecoLote(): void {
    this.buscandoEndereco = true;

    this.authService.loginOms().subscribe({
      next: (token: any) => {
        this.locationService
          .obterEndereco(token.token, this.cep, this.numero)
          .subscribe({
            next: (res: any) => {
              this.fidelidadeService
                .listaEnderecosLote(
                  this.idExperiencia,
                  res[0].latitude,
                  res[0].longitude
                )
                .subscribe({
                  next: (res: any) => {
                    this.processarSucessoObterLotesProximos(res.resultado);
                  },
                  error: (err: any) => this.processarFalhaObterProximos(err),
                });
            },
            error: (err: any) => this.processarFalhaObterProximos(err),
          });
      },
    });
  }

  processarSucessoObterEndereco(res: any) {
    const endereco = res[0];

    this.fidelidadeService
      .obterListaEnderecosProximos(
        this.idExperiencia,
        endereco.latitude,
        endereco.longitude
      )
      .subscribe({
        next: (res: any) => this.processarSucessoObterProximos(res),
        error: (err: any) => this.processarFalhaObterProximos(err),
      });
  }

  private processarSucessoObterProximos(res: any) {
    const lote: any[] = [];

    for (let i = 0; i < res.resultado.length; i++) {
      const endereco = res.resultado[i];

      lote.push({
        id: i + 1,
        parceiroEndereco: {
          id: endereco.id,
          idParceiro: endereco.idParceiro,
          nome: endereco.endereco.nome,
          cep: endereco.endereco.cep,
          latitude: endereco.endereco.latitude,
          longitude: endereco.endereco.longitude,
          distancia: endereco.endereco.distancia,
          logradouro: endereco.endereco.logradouro,
          cidade: endereco.endereco.cidade,
          bairro: endereco.endereco.bairro,
          estado: endereco.endereco.estado,
          numero: endereco.endereco.numero,
          complemento: endereco.endereco.complemento,
          descricao: endereco.descricao,
        },
      });
    }

    this.enderecosLote = lote;
    this.buscandoEndereco = false;
  }

  private processarSucessoObterLotesProximos(res: any) {
    const lote: any[] = [];

    for (let i = 0; i < res.length; i++) {
      const endereco = res[i];

      lote.push({
        id: res[i].idLote,
        parceiroEndereco: {
          id: endereco.id,
          idParceiro: endereco.idParceiro,
          nome: endereco.endereco.nome,
          cep: endereco.endereco.cep,
          latitude: endereco.endereco.latitude,
          longitude: endereco.endereco.longitude,
          distancia: endereco.endereco.distancia,
          logradouro: endereco.endereco.logradouro,
          cidade: endereco.endereco.cidade,
          bairro: endereco.endereco.bairro,
          estado: endereco.endereco.estado,
          numero: endereco.endereco.numero,
          complemento: endereco.endereco.complemento,
          descricao: endereco.descricao,
        },
      });
    }

    this.enderecosLote = lote;
    this.buscandoEndereco = false;
  }

  private processarFalhaObterProximos(err: any) {
    console.error('Ocorreu um erro ao obter os endereços próximos', err);
    this.buscandoEndereco = false;
  }

  public formatarValorParaDuasCasasDecimais(valor: number): string {
    return valor.toFixed(2);
  }

  obterParceiroEndereco() {
    this.fidelidadeService.buscarParceiroPorId(this.parceiroId).subscribe({
      next: (res: any) => {
        this.listaEnderecos = res.resultado.parceiroEndereco;
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }

  public membroPertenceAoNivel(): boolean {
    return this.niveis.some((x) => x.idNivel === this.membro.idNivel);
  }

  public selecionarLoteDefault(idLoteSelecionado: number)
  {
    this.idLoteSelecionado = 0;

    if(idLoteSelecionado > 0)
    {
      this.loteSelecionado = this.lotes.find(x => x.id == idLoteSelecionado);
      this.idLoteSelecionado = idLoteSelecionado;
    }
    else
    {

      if(this.lotes != null && this.lotes != undefined && this.lotes.length > 0)
      {
        this.lotes.sort(function(a,b){
          return Date.parse(a.dataInicio) - Date.parse(b.dataInicio);
        });
      }

      if (this.tipo === 1 || this.tipo === 6) {
        for (let i = 0; i < this.lotes.length; i++) {
          const lote = this.lotes[i];

          if (i === this.lotes.length - 1) {
            this.idLoteSelecionado = lote.id;
            break;
          }

          if (lote.quantidadeDisponivel > 0) {
            this.idLoteSelecionado = lote.id;
            break;
          }
        }
      }

      if (this.tipo === 2 || this.tipo === 3 || this.tipo === 5)
        if(this.loteSelecionado != null)
          this.idLoteSelecionado = this.loteSelecionado.id;

      if (this.tipo === 4)
        if(this.enderecoSelecionado != null)
          this.idLoteSelecionado = this.enderecoSelecionado.id;

      if(this.idLoteSelecionado > 0)
        this.loteSelecionado = this.lotes.find(x => x.id == this.idLoteSelecionado);
    }

    this.tratarQuantidade(this.loteSelecionado, 1);
  }

  public tratarQuantidade(lote: any | undefined, quantidade: number)
  {
    this.loteQuantidadeSelecionada = quantidade;

    var pontuacao = lote != undefined ? lote.ponto : this.pontuacao;

    this.pontuacaoLoteFinal = pontuacao * quantidade;

    if(lote != null && lote != undefined)
      this.maximoPopup = this.quantidadePorMembro > lote.quantidadeDisponivel ? lote.quantidadeDisponivel : this.quantidadePorMembro;
    else
      this.maximoPopup = this.quantidadePorMembro;
  }
}
